import React from 'react'
import styled from 'styled-components'
import { color, compose, SpaceProps } from 'styled-system'
import Box from '@zuto/core/src/box'
import { textStyle } from '@zuto/utilities'

export interface TermsAndConditionsProps extends React.HTMLAttributes<HTMLDivElement>, SpaceProps {

}

const StyledTermsAndConditions = styled(Box)`
  box-sizing: border-box;
  border-radius: 12px;
  width: 100%;
  background: #F7F7F7;
  a {
    text-decoration: none;
    ${(props) => compose(color, textStyle(props))({
    ...props,
    textStyle: 'body.smallPrint.medium',
    color: 'secondary.1'
  })}
  }
`

const TermsAndConditions = ({ children, ...props }: TermsAndConditionsProps): JSX.Element => (
  <StyledTermsAndConditions textStyle="body.smallPrint.regular" px={5} py={[4, 5]} {...props}>
    {children}
  </StyledTermsAndConditions>
)
export default TermsAndConditions
